import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../BaseUrl/baseurl";
import axios from "axios";
import { usersAPIs } from "../../Components/constants/constants";
const token = localStorage.getItem("token");
const headers = {
    headers: {
        authorization: token
    }
};

export const getDashboardData = createAsyncThunk(
    "getDashboardData",
    async () => {
        // console.log("I am response.data here", response.data);
        let response;
        try {
            response = await axios.get(`${baseUrl}/admins/allcounts`, headers);
        } catch (error) {
            console.log(error);
            return {};
        }
        return response.data;
    }
);

// Define the initial state for the slice

const dashboardDataSlice = createSlice({
    name: "dashboardData",
    initialState: {
        dashboardData: {}
    },

    reducers: {
        dummyMethod: () => {}
    },
    extraReducers(builder) {
        // get Users List
        builder
            .addCase(getDashboardData.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getDashboardData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.dashboardData = action.payload;
            })
            .addCase(getDashboardData.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export const { dummyMethod } = dashboardDataSlice.actions;

export default dashboardDataSlice.reducer;
